import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import io, { Socket } from 'socket.io-client';

interface SocketContextType {
    socket: Socket | null;
}

const SocketContext = createContext<SocketContextType | undefined>(undefined);

interface SocketProviderProps {
    children: ReactNode;
}

export const SocketProvider: React.FC<SocketProviderProps> = ({ children }) => {
    const [socket, setSocket] = useState<Socket | null>(null);
    const token = localStorage.getItem('accessToken');
    const url = process.env.REACT_APP_FIELD_API_WS_HOST || '';
    
    useEffect(() => {
        const newSocket = io(url, { query: { token } });
        setSocket(newSocket);

        return () => {
            newSocket.disconnect();
        };
    }, []);

    return (
        <SocketContext.Provider value={{ socket }}>
            {children}
        </SocketContext.Provider>
    );
};

export const useSocket = (): any => {
    const context = useContext(SocketContext);

    if (!context || !context.socket) {
        return null;
    }

    return context.socket;
};